Menu = {

    el:{},
    mainMenu:{},
    isMobile:false,

    init: function(){
        this.el = $('.topheader');

        this.MainMenu.init();
        this.Button.init();
        this.Plus.init();
        this.Dropdown.init();
        Menu.resize();
    },

    resize: function(){
        Menu.isMobile = window.innerWidth >= 980 ? false : true;

        if (Menu.isMobile){
            Menu.MainMenu.el.addClass('hidden');
            Menu.Button.el.removeClass('openned');
        } else {
            Menu.MainMenu.el.removeClass('hidden hide show');
        }
    },

    MainMenu: {
        isVisible:false,
        el:{},

        init: function(){
            this.el = Menu.el.find('.navigation');
            this.content = $('[component="page"]');
            this.Item.init();
        },

        show: function(){
             this.el.addClass('show').removeClass('hide hidden');
             Menu.el.addClass('openned');
             this.content.addClass('menuOpen');
             this.isVisible = true;
        },

        hide: function(){
            this.el.addClass('hide').removeClass('show');
            Menu.el.removeClass('openned');
            this.content.removeClass('menuOpen');
            this.isVisible = false;
            setTimeout( function(){
               Menu.MainMenu.el.addClass('hidden');
            },300)

            Menu.Button.el.removeClass('openned');
        },

        Item: {
            init: function(){
                Menu.MainMenu.el.find('a').click(function(event) {
                    Menu.Dropdown.hideAll();
                    if(!Menu.MainMenu.isVisible) return;
                    Menu.MainMenu.hide();
                });
            }
        }
    },

    Button: {
        el:{},

        init: function(){
            this.el = Menu.el.find('.mobile-button');
            this.bind();
        },

        bind: function(){

            this.el.unbind('click')
             .click(function(event) {
                 event.preventDefault();

                 if ($(this).is('.openned')){
                    Menu.MainMenu.hide();
                    $(this).removeClass('openned');
                 } else {
                    Menu.MainMenu.show();
                    $(this).addClass('openned');
                    
                 }
             });
         }
    },

    Plus: {
         el:{},

        init: function(){

            this.el =  Menu.el.find('nav .m-icon');
            this.bind();
        },

        bind: function(){

            this.el.unbind('click')
             .click(function(event) {
                 event.preventDefault();
                 event.stopPropagation();

                var item = $(this).closest('li');
                var dropdown = item.find('.dropdown')

                 if (!item.is('.open')){
                    Menu.el.find('.item.open .dropdown').slideUp(300);
                    Menu.el.find('.item.open').removeClass('open');
                    dropdown.slideDown(300);
                    item.addClass('open');
                 } else {
                    dropdown.slideUp(300);
                    item.removeClass('open');
                    
                 }

                
             });
         }
    },

    Dropdown: {

        init: function(){

            var menuItem = Menu.el.find('nav .hasChildren');

            menuItem.each(function(index, el) {
                Menu.Dropdown.bind($(this));
            });
        },

        bind: function(menuItem){
            menuItem.unbind('mouseover')
                .mouseover(function(event) {
                    Menu.Dropdown.show($(this));
                })
                .unbind('mouseleave')
                .mouseleave(function(event) {
                    Menu.Dropdown.hide($(this));
                })
        },

        show: function(menuItem){
            if(Menu.isMobile) return;
            menuItem.find('.dropdown').slideDown(300);
        },

        hide: function(menuItem){
            if(Menu.isMobile) return;
            menuItem.find('.dropdown').stop().slideUp(300);
        },

        hideAll: function(){
            Menu.el.find('.dropdown').stop().slideUp(300);
        }
    }

}

